import script from "./Success.vue?vue&type=script&setup=true&lang=ts"
export * from "./Success.vue?vue&type=script&setup=true&lang=ts"

export default script